export const jobTypes = {
  expert: "expert",
  skilled: "skilled"
};
